import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
declare var $: any;


export interface ICarouselCardImages {
  pujaId: any;
  pujaType: any;
  pujaName: any;
  pujaDescription: any;
  pujaImage: any;
}

export interface ICarouselCardTVImages {
  id: any;
  categoryId: any;
  url: any;
  title: any;
  description: any;
}

@Component({
  selector: 'app-carousel-card',
  templateUrl: './carousel-card.component.html',
  styleUrls: ['./carousel-card.component.scss']
})
export class CarouselCardComponent implements OnInit , AfterViewInit{

  constructor() { }

  @Input() lists: ICarouselCardImages[];

  @Input() shekTvlists: ICarouselCardTVImages[];

  @Input() homePagelists: ICarouselCardTVImages[];

  @Input() astrologylists: ICarouselCardTVImages[];

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    const minterval = setInterval(() => {
      if (this.lists != null && this.lists.length > 0){
         clearInterval(minterval);
         this.carouselInit();
      } else if (this.shekTvlists != null && this.shekTvlists.length > 0) {
        clearInterval(minterval);
        this.carouselInit();
      } else if (this.homePagelists != null && this.homePagelists.length > 0) {
        clearInterval(minterval);
        this.carouselInit();
      }
    }, 250);
  }

  carouselInit(): void {

    $('[data-toggle="offcanvas"]').on('click', function () {
    $('.offcanvas-collapse').toggleClass('open');
    });

    $('.most-popular').not('.slick-initialized').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    $('.reviews').not('.slick-initialized').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
          }
        ]
    });

    $(function() {
        $('#myList a:last-child').tab('show');
    });
  }
}
